require('./angular-aria');
module.exports = 'ngAria';



//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/angular-aria/index.js
// module id = 62
// module chunks = 0